﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import { SoPThemeConstants } from "~irad/Styling/SoPThemeConstants";
import type { SoPNLConsilioTheme } from "~jrad/Styling/SoPNLConsilioTheme";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

// TODO: Replace with actual SoPThemeConstantsV2 when PR !21491 is merged
const SoPThemeConstantsV2 = {
    Typography: {
        Paragraph: {
            fontFamily: SoPThemeConstants.defaultFont.replace(
                "Whitney SSM A, Whitney SSm B, ",
                ""
            ),
            fontSize: "18px",
            fontWeight: "normal",
        },
        Label: {
            fontFamily: SoPThemeConstants.defaultFont.replace(
                "Whitney SSM A, Whitney SSm B, ",
                ""
            ),
            fontSize: "18px",
            fontWeight: "bold",
        },
    },
};

export default createUseStyles((theme: SoPNLConsilioTheme) => ({
    pageContainer: {
        margin: "0 auto",
        padding: "0 42px",
        width: "100%",
        maxWidth: "996px",
    },
    errorMessage: {
        color: "red",
        fontFamily: theme.constants.defaultFont,
        fontSize: "18px",
        fontWeight: "normal",
        whiteSpace: "pre-line",
    },
    introHeader: {
        color: theme.constants.textColor,
        fontFamily: theme.constants.headerFont,
        fontSize: "40px",
        fontWeight: "normal",
    },
    introDesc: {
        ...SoPThemeConstantsV2.Typography.Paragraph,
        color: theme.constants.textColor,

        whiteSpace: "pre-line",

        "& a": {
            color: "#009fdf",

            "&:hover": {
                color: "#002d72",
            },
        },
    },
    introDivider: {
        height: 0,
        width: "100%",
        borderTop: "1px solid #777777",
        borderBottom: "none",
        margin: "18px 0",
    },
    overlayDescription: {
        fontFamily: theme.constants.defaultFont,
        fontSize: "16px",
    },
}));
